/**
 * Formats a person's name as "lastName, firstName"
 * Used for managers and individual clients
 */
export function formatPersonName(
  firstName?: string | null,
  lastName?: string | null
): string {
  const first = firstName?.trim() || '';
  const last = lastName?.trim() || '';

  if (last && first) {
    return `${last}, ${first}`;
  }
  if (last) {
    return last;
  }
  if (first) {
    return first;
  }
  return '';
}

/**
 * Formats a client name for display
 * If firstName/lastName are provided, formats as "lastName, firstName"
 * Otherwise falls back to the existing name field
 */
export function formatClientName(
  name?: string | null,
  firstName?: string | null,
  lastName?: string | null
): string {
  // If individual name fields are populated, format as "lastName, firstName"
  if (firstName || lastName) {
    return formatPersonName(firstName, lastName);
  }
  // Otherwise use the existing name field as-is
  return name || '';
}

/**
 * Formats a manager name for display
 * Uses firstName/lastName if available, otherwise falls back to the legacy name field
 */
export function formatManagerName(
  name: string,
  firstName?: string | null,
  lastName?: string | null
): string {
  // If individual name fields are populated, format as "lastName, firstName"
  if (firstName || lastName) {
    return formatPersonName(firstName, lastName);
  }
  // Otherwise use the existing name field as-is (for backward compatibility)
  return name || '';
}
